import { CheckoutItbDirectResponse } from '../../models/checkout/checkout-itb-direct-response.interface';

export const mockCheckoutItbDirectResponse: CheckoutItbDirectResponse = {
  itbId: 'itbId',
  paymentRedirectUrl: 'paymentRedirectUrl',
};
